/** * 用户管理 用户列表 */
<template>
  <div id="realName">

    <div class="header">
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>实名认证</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="searchBox">
      <!-- 搜索筛选 -->
      <el-form :inline="true" style="margin-top: 20px;">
        <el-form-item>
          <el-select style="width: 180px;" size="small" v-model="aduitStatus" placeholder="请选择审核状态">
            <el-option v-for="(type, index) in payType" :label="type.key" :value="type.value" :key="index">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input size="small" style="width: 180px;" v-model="username" placeholder="输入用户昵称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input size="small" style="width: 180px;" v-model="mobile" placeholder="请输入用户手机账号"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="chongzhi">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="tabBox">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="实名认证" name="sf"></el-tab-pane>
        <el-tab-pane label="学生认证" name="xs"></el-tab-pane>
        <el-tab-pane label="企业认证" name="qy"></el-tab-pane>
      </el-tabs>
    </div>


    <div class="content" v-if="activeName == 'sf'">
      <!--列表-->
      <el-table size="small" height="100%" :data="listData" highlight-current-row v-loading="loading" border
        element-loading-text="拼命加载中" style="width: 100%;" v-horizontal-scroll>
        <el-table-column align="center" sortable type="index" label="序号"></el-table-column>

        <el-table-column align="center" prop="sfz1" label="身份证正面" width="160">
          <template slot-scope="scope">
            <el-image v-if="scope.row.sfz1" style="width: 140px;height: 140px;" :src="scope.row.sfz1"
              :preview-src-list="[scope.row.sfz1]" />
            <div v-if="scope.row.sfz1 == null">暂无图片</div>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="img" label="身份证反面" width="160">
          <template slot-scope="scope">
            <el-image v-if="scope.row.sfz2" style="width: 140px;height: 140px;" :src="scope.row.sfz2"
              :preview-src-list="[scope.row.sfz2]" />
            <div v-if="scope.row.sfz2 == null">暂无图片</div>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="nickName" label="用户昵称" width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" prop="mobile" label="电话号码" width="120" show-overflow-tooltip>
        </el-table-column>

        <el-table-column align="center" prop="sfzStatus" label="审核状态" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.sfzStatus == 1">待审核</div>
            <div v-if="scope.row.sfzStatus == 2">审核通过</div>
            <div v-if="scope.row.sfzStatus == 3">审核不通过</div>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="sfzRemark" label="驳回理由" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.sfzRemark">{{ scope.row.sfzRemark }}</div>
          </template>
        </el-table-column>


        <el-table-column align="center" prop="createTime" label="创建时间" width="150">
          <template slot-scope="scope">
            <div>{{ transformDate(scope.row.createTime) }}</div>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="updateTime" label="更新时间" width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.updateTime">{{ transformDate(scope.row.updateTime) }}</div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作" show-overflow-tooltip width="220px" fixed="right">
          <template slot-scope="scope" v-if="scope.row.sfzStatus == 1">
            <el-button size="mini" type="primary" @click="upUserYes(scope.row)">审核通过</el-button>
            <el-button size="mini" type="danger" @click="upUserNo(scope.row)">审核不通过</el-button>
          </template>
        </el-table-column>
      </el-table>

    </div>

    <div class="content" v-if="activeName == 'xs' || activeName == 'qy'">
      <!--列表-->
      <el-table size="small" height="100%" :data="listData" highlight-current-row v-loading="loading" border
        element-loading-text="拼命加载中" style="width: 100%;" v-horizontal-scroll>
        <el-table-column align="center" sortable type="index" label="序号"></el-table-column>

        <el-table-column align="center" prop="img" label="证件照正面" width="160">
          <template slot-scope="scope">
            <el-image v-if="scope.row.img && scope.row.img.length > 0" style="width: 140px;height: 140px;"
              :src="scope.row.img[0]" :preview-src-list="[scope.row.img[0]]" />
            <div v-if="scope.row.img.length == 0">暂无图片</div>
          </template>
        </el-table-column>
        <el-table-column prop="img" label="证件照反面" width="160">
          <template slot-scope="scope">
            <el-image v-if="scope.row.img && scope.row.img.length > 0" style="width: 140px;height: 140px;"
              :src="scope.row.img[1]" :preview-src-list="[scope.row.img[1]]" />
            <div v-if="scope.row.img.length == 0">暂无图片</div>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="nickName" label="用户昵称" width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" prop="mobile" label="电话号码" width="120" show-overflow-tooltip>
        </el-table-column>

        <el-table-column align="center" prop="sfzStatus" label="审核状态" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 1">待审核</div>
            <div v-if="scope.row.status == 2">审核通过</div>
            <div v-if="scope.row.status == 3">审核不通过</div>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="remark" label="驳回理由" width="160"></el-table-column>

        <el-table-column align="center" prop="createTime" label="创建时间" width="150">
          <template slot-scope="scope">
            <div>{{ transformDate(scope.row.createTime) }}</div>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="updateTime" label="更新时间" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.updateTime">{{ transformDate(scope.row.updateTime) }}</div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作" show-overflow-tooltip width="220px" fixed="right">
          <template slot-scope="scope" v-if="scope.row.status == 1">
            <el-button size="mini" type="primary" @click="btnOperate(scope.row, 1)">审核通过</el-button>
            <el-button size="mini" type="danger" @click="btnOperate(scope.row, 2)">审核不通过</el-button>
          </template>
        </el-table-column>
      </el-table>

    </div>


    <!-- 分页组件 -->

    <div class="pageTurning">
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>

    <!-- 用户圈层详情页 -->
    <el-dialog title="用户圈层详情页：" :visible.sync="editFormDetails" width="60%">
      <el-table size="small" :data="QCData" highlight-current-row v-loading="loading" border
        element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" sortable prop="grade" label="等级"></el-table-column>
        <el-table-column align="center" sortable prop="name" label="圈层名称"></el-table-column>
        <el-table-column align="center" sortable prop="description" label="描述"></el-table-column>
        <el-table-column align="center" sortable prop="amount" label="金额"></el-table-column>
        <el-table-column align="center" sortable prop="money" label="奖学金"></el-table-column>
        <el-table-column align="center" sortable prop="createTime" label="创建时间">
          <template slot-scope="scope">
            <div>{{ transformDate(scope.row.createTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="XiugaiQC(scope.row)"
              v-if="scope.row.isBuy === 0">开通圈层</el-button>
            <el-button size="mini" type="success" v-if="scope.row.isBuy === 1">已开通</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 公司详情 -->
    <el-dialog title="用户公司详情页：" :visible.sync="editFormDetailsGS" width="80%">
      <el-table size="small" :data="Gongsi" highlight-current-row v-loading="loading" border
        element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" sortable prop="currentName" label="当前所在层级数" width="180"></el-table-column>
        <el-table-column align="center" sortable prop="image" label="策划书图片">
          <template slot-scope="scope">
            <el-image v-if="scope.row.image" style="width: 90px;height: 90px;" :src="scope.row.image"
              :preview-src-list="[scope.row.image]" />
          </template>
        </el-table-column>
        <el-table-column align="center" sortable prop="size" label="人数"></el-table-column>
        <el-table-column align="center" sortable prop="depart" label="部门"></el-table-column>
        <el-table-column align="center" sortable prop="data" label="资料">
          <template slot-scope="scope">
            <el-image v-if="scope.row.data" style="width: 90px;height: 90px;" :src="scope.row.data"
              :preview-src-list="[scope.row.data]" />
          </template>
        </el-table-column>
        <el-table-column align="center" sortable prop="tax" label="税收"></el-table-column>
        <el-table-column align="center" sortable prop="registered" label="缴纳注册资本金" width="180"></el-table-column>
        <el-table-column align="center" sortable prop="salary" label="合计工资"></el-table-column>
        <el-table-column align="center" sortable prop="createTime" label="创建时间" width="180">
          <template slot-scope="scope">
            <div>{{ transformDate(scope.row.createTime) }}</div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>


  </div>
</template>

<script>
import {
  getUserList,
  aduitUser,
  updateUserStatus,
  getUserCirclesList,
  openCircles,
  getUserCompanyRecoordList,
  getAuditSfzUserList,
  aduitSfz,
  authentication_x_q,
  examineApi
} from "../../api/userMG";
import Pagination from "../../components/Pagination";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

// 工具栏配置
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ direction: "rtl" }], // text direction

  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ["link", "image", "video"], // 对于图片上传这是重点
  ["clean"] // remove formatting button
];

export default {
  data() {
    return {
      aduitStatus: '',
      payType: [
        { key: "全部", value: '-1' },
        { key: "待审核", value: '1' },
        { key: "审核成功", value: '2' },
        { key: "审核不通过", value: '3' }
      ],
      uploadVisible: false,
      cursorIndex: 0,
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: value => {
                if (value) {
                  // 在这里编写图片按钮点击操作
                  this.uploadVisible = true;
                  this.cursorIndex = this.$refs.QuillEditor.quill.getSelection().index;
                } else {
                  this.quill.format("image", false);
                }
              }
            }
          }
        }
      },
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "预览",
      statusType: [
        { key: "请选择", value: 0 },
        { key: "正常", value: 1 },
        { key: "冻结", value: 2 }
      ],

      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      },
      username: "",
      mobile: '',
      keyword: "",
      nickName: "",
      nickid: "",
      status: -1,
      from: {
        title: "",
        briefContent: "",
        content: "",
        userId: "",
        sendType: 0
      },
      options: [
        {
          value: -1,
          label: "全部"
        },
        {
          value: 0,
          label: "审核中"
        },
        {
          value: 1,
          label: "审核通过"
        },
        {
          value: 2,
          label: "审核未通过"
        }
      ],
      editFormDetails: false,
      QCData: [],
      Gongsi: [],
      editFormDetailsGS: false,
      activeName: 'sf'
    };
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(1);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    handleClick(e) {
      console.log(this.activeName)
      if (this.activeName == 'sf') {
        this.getdata(1)
      } else if (this.activeName == 'xs') {
        this.authenticationData(1, 1)
      } else if (this.activeName == 'qy') {
        this.authenticationData(1, 0)
      }
    },
    // 开通圈层
    XiugaiQC(row) {
      this.$confirm("确定开通此圈层吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success"
      })
        .then(() => {
          let data = {
            userId: this.userId,
            circlesId: row.id
          };
          openCircles(data).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(err => {
          this.$message({
            type: "info",
            message: "已取消开通"
          });
        });
    },
    // 查看公司详情页
    openGongsi(row) {
      this.editFormDetailsGS = true;
      let data = {
        userId: row.id
      };
      getUserCompanyRecoordList(data).then(res => {
        this.loading = false;
        if (res.code != 200) {
          this.$Message({
            type: "info",
            message: res.msg
          });
        } else {
          this.Gongsi = res.data.list;
          return;
        }
      });
    },
    // 查看用户圈层详情页
    openQuanceng(row) {
      this.loading = true;
      this.editFormDetails = true;
      this.userId = row.id;
      let data = {
        userId: row.id
      };
      getUserCirclesList(data).then(res => {
        this.loading = false;
        if (res.code != 200) {
          this.$Message({
            type: "info",
            message: res.msg
          });
        } else {
          this.QCData = res.data.list;
          return;
        }
      });
    },
    // 启用用户
    upUserYes(row) {
      console.log("row", row);
      this.$confirm("确定审核通过此用户吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success"
      })
        .then(() => {
          let data = {
            id: row.id,
            sfzStatus: 2
          };
          aduitSfz(data).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.getdata(1);
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(err => {
          this.$message({
            type: "info",
            message: "已取消启用"
          });
        });
    },
    // 禁用用户
    upUserNo(row) {
      this.$prompt("请输入驳回理由", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(({ value }) => {
          let data = {
            id: row.id,
            sfzStatus: 3,
            sfzRemark: value
          };
          aduitSfz(data).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.getdata(1);
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入"
          });
        });
      //   this.$confirm("确定审核不通过吗?", "提示", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "success"
      //   })
      //     .then(() => {
      //       let data = {
      //         id: row.id,
      //         sfzStatus: 2
      //       };

      //       return;
      //       aduitSfz(data).then(res => {
      //         if (res.code == 200) {
      //           this.$message.success(res.msg);
      //           this.getdata(1);
      //         } else {
      //           this.$message.error(res.msg);
      //         }
      //       });
      //     })
      //     .catch(err => {
      //       this.$message({
      //         type: "info",
      //         message: "已取消禁用"
      //       });
      //     });
    },
    // 审核通过
    updateYes(row) {
      console.log("row", row);
      this.$confirm("确定通过吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success"
      })
        .then(() => {
          let data = {
            id: row.id,
            status: 1
          };
          aduitUser(data).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.getdata(1);
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(err => {
          this.$message({
            type: "info",
            message: "已取消通过"
          });
        });
    },

    // 审核不通过
    updateNo(row) {
      console.log("row", row);
      this.$confirm("确定不通过吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success"
      })
        .then(() => {
          let data = {
            id: row.id,
            status: 2
          };
          aduitUser(data).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.getdata(1);
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(err => {
          this.$message({
            type: "info",
            message: "已取消不通过"
          });
        });
    },
    // 学生，企业审核认证
    btnOperate(item, num) {
      let that = this

      if (num == 1) {
        this.$confirm('是否进行审核操作！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'success'
        }).then(() => {

          if (num == 1) {
            examineApi({
              id: item.id,
              status: 2
            }).then(res => {
              if (res.code == 200) {
                this.$message.success('审核通过')
                this.getdata(1);
              }
            })
          }
          if (this.activeName == 'xs') {
            this.authenticationData(1, 1)
          } else if (this.activeName == 'qy') {
            this.authenticationData(1, 0)
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消操作'
          });
        });

      } else if (num == 2) {
        this.$prompt("请输入驳回理由", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        })
          .then(({ value }) => {
            examineApi({
              id: item.id,
              status: 3,
              remark: value
            }).then(res => {
              if (res.code == 200) {
                this.$message.success('审核不通过')
                if (this.activeName == 'xs') {
                  this.authenticationData(1, 1)
                } else if (this.activeName == 'qy') {
                  this.authenticationData(1, 0)
                }
              }
            })

          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "取消输入"
            });
          });
      }



    },
    selectChange(e) {
      console.log("e======", e);
      this.getdata(1);
    },

    sexf: function (row) {
      if (row.sex == 1) {
        return "男";
      } else {
        return "女";
      }
    },

    zhuangTai: function (row) {
      if (row.status == 0) {
        return "审核中";
      } else if (row.status == 1) {
        return "审核通过";
      } else if (row.status == 2) {
        return "审核未通过";
      }
    },

    // 获取数据方法
    getdata(page) {
      this.loading = true;
      var parameter = {
        mobile: this.mobile,
        // status: this.status,
        nickName: this.username,
        id: this.nickid,
        page: (page - 1) * 20,
        aduitStatus: this.aduitStatus
      };
      getAuditSfzUserList(parameter).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.listData = res.data.list;
          this.pageparm.currentPage = page;
          this.pageparm.total = res.data.count;
          return;
        }
        this.$message({
          type: "info",
          message: res.msg
        });
      });
    },
    // 获取企业认证，学生认证 
    authenticationData(page, type) {
      let that = this

      authentication_x_q({
        mobile: this.mobile,
        status: this.status,
        page: (page - 1) * 20,
        nickName: this.username,
        type: type, //类型 0企业认证 1学生认证
      }).then(res => {
        if (res.code == 200) {
          this.loading = false;
          if (res.code == 200) {

            res.data.list.forEach((item, index) => {

              if (item.img) {
                item.img = item.img.split(',')
              } else {
                item.img = []
              }

            })
            this.listData = res.data.list;
            this.pageparm.currentPage = page;
            this.pageparm.total = res.data.count;
            return;
          }
          this.$message({
            type: "info",
            message: res.msg
          });
        }
      })

    },
    // 审核操作 

    // 分页插件事件
    callFather(parm) {
      this.pageparm.page = parm.currentPage;
      this.getdata(parm.currentPage);
    },
    // 搜索事件
    search() {
     
      if (this.activeName == 'sf') {
        this.getdata(1)
      } else if (this.activeName == 'xs') {
        this.authenticationData(1, 1)
      } else if (this.activeName == 'qy') {
        this.authenticationData(1, 0)
      }
    },
    // 重置数据
    chongzhi() {
      this.keyword = "";
      this.status = -1;
      this.nickName = "";
      this.nickid = "";
      if (this.activeName == 'sf') {
        this.getdata(1)
      } else if (this.activeName == 'xs') {
        this.authenticationData(1, 1)
      } else if (this.activeName == 'qy') {
        this.authenticationData(1, 0)
      }
    }
  }
};
</script>

<style scoped>
.userRole {
  width: 100%;
}

#realName {
  height: 100%;
  display: flex;
  flex-direction: column;
}

#realName .header {
  flex: none;
}

#realName .searchBox {
  flex: none;
}

#realName .content {
  flex: auto;
  overflow: auto;
}

#realName .pageTurning {
  flex: none;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/terrace/realName.vue